interface ButtonStyle {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
}

export const getButtonStyle = (ctaType: string | undefined) => {
  let buttonStyle: ButtonStyle = { primary: true };
  if (ctaType === 'secondary' || !ctaType) {
    buttonStyle = { secondary: true } as any;
  }
  if (ctaType === 'tertiary') {
    buttonStyle = { tertiary: true } as any;
  }
  return buttonStyle;
};
